import styled from "styled-components";

import BurgerMenuStyled from "../components/styles/BurgerMenu.styled";

const StyledHeader = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 64px;
  z-index: 100;
  background-color: ${({ theme }) => theme.colors.header};
  box-shadow: ${({ theme }) => theme.shadows.card};

  .full-height {
    height: 100%;
  }

  ${BurgerMenuStyled} {
    display: none;
  }

  @media all and (max-width: ${({ theme }) => theme.mobileBreakingPoint}) {
    ${BurgerMenuStyled} {
      display: flex;
    }

    .separator {
      display: none;
    }

    .airline-logo-mobile {
      max-width: 120px;
    }
  }
`;

export default StyledHeader;
